module.exports = __webpack_public_path__ + "img/3-WIDGETLOYALTYPAGE-CONFIGURATION-BLURBS.57c184f4.jpg";